// Centro por defecto si el evento aún no tiene población: Santiago de Compostela
export const DEFAULT_CENTER = [42.8805, -8.5457];

export const EVENT_TYPES = {
  carrera: "Carrera",
  procesion: "Procesión",
  fiesta: "Fiesta",
  cabalgata: "Cabalgata",
  deportivo: "Evento deportivo",
  otro: "Otro",
};

export const STATUS = {
  planificado: { label: "Planificado", cls: "bg-sky-500/15 text-sky-300 border-sky-500/40" },
  en_curso: { label: "En curso", cls: "bg-amber-500/15 text-amber-300 border-amber-500/40" },
  finalizado: { label: "Finalizado", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" },
};

export const KINDS = {
  route: { label: "Recorrido del evento", short: "Recorrido", color: "#0ea5e9", hint: "Clic para añadir vértices del recorrido. Pulse Terminar." },
  cut_point: { label: "Punto de corte", short: "Corte", color: "#ef4444", hint: "Clic en el cruce donde se corta el tráfico." },
  street_cut: { label: "Tramo de calle cortado", short: "Tramo", color: "#f97316", hint: "Clic en inicio y final del tramo (y puntos intermedios). Pulse Terminar." },
  no_parking: { label: "Zona sin estacionamiento", short: "Zona", color: "#f59e0b", hint: "Clic para dibujar el contorno de la zona. Pulse Terminar." },
  special_path: { label: "Zona de tránsito especial", short: "Tránsito esp.", color: "#a855f7", hint: "Marque el recorrido de la zona que puede habilitarse al tráfico (plaza, explanada, paso restringido). Se usará para calcular desvíos. Pulse Terminar." },
  sign: { label: "Objeto de señalización", short: "Objeto", color: "#f59e0b", hint: "Pulse en el mapa para colocar el objeto. Puede colocar varios seguidos; pulse X para terminar." },
  reversed_oneway: { label: "Sentido invertido", short: "Sentido inv.", color: "#ec4899", hint: "Pulse una calle de sentido único (capa turquesa) para invertirla, o dibuje el tramo a mano en el NUEVO sentido de circulación (del primer al último punto) y pulse Terminar." },
};

export const RESOURCES = [
  { key: "policia_pie", label: "Agentes Policía Local (a pie)", hint: "Regulación de tráfico y desvíos" },
  { key: "patrullas_coche", label: "Patrullas en vehículo", hint: "2 agentes · 22 km/h · relevos rápidos" },
  { key: "patrullas_moto", label: "Patrullas en moto", hint: "Máxima movilidad · escolta de comitiva" },
  { key: "auxiliares", label: "Auxiliares de Policía Local", hint: "Tareas simples, retirada de vehículos" },
  { key: "proteccion_civil", label: "Voluntarios Protección Civil", hint: "Señalización estática y vallas" },
  { key: "organizadores", label: "Personal de la organización", hint: "Custodia de vallas en recorrido" },
];

export const CATEGORY = {
  escolta: { label: "Escolta comitiva", color: "#6366f1" },
  regulacion: { label: "Regulación / corte", color: "#ef4444" },
  retirada: { label: "Retirada vehículos", color: "#f59e0b" },
  corte_estatico: { label: "Custodia de vallas", color: "#10b981" },
  senalizacion: { label: "Montaje señalización", color: "#0ea5e9" },
  habilitacion: { label: "Habilitar paso especial", color: "#a855f7" },
  desmontaje: { label: "Retirada de vallas", color: "#64748b" },
  asignacion: { label: "Puesto asignado", color: "#0ea5e9" },
};

export const ROLES = {
  admin: "Administrador",
  usuario: "Usuario",
  observador: "Observador",
};

export const DEFAULTS = {
  route: { name: "Recorrido", speed_kmh: 4, passage_min: 20, escort: true, escort_agents: 2 },
  cut_point: { auto_time: true, staff_required: 2, regulation: true, detour: true, detour_staff: true },
  street_cut: { auto_time: true, staff_required: 1, regulation: false, detour: true, detour_staff: true },
  no_parking: { auto_time: false, staff_required: 1 },
  special_path: { staff_required: 1, habilitation_staff: true },
  reversed_oneway: { staff_required: 1, reversal_staff: true },
  sign: { rotation: 0, qty: 1 },
};
